
  export const ADDRESSS_RECEIVED = "ADDRESSS_RECEIVED";
  export const SET_ADDRESS = "SET_ADDRESS";
  export const CREATE_ADDRESS = "CREATE_ADDRESS";
  export const SET_PROPERTY_ADDRESS = "SET_PROPERTY_ADDRESS";
  